import { motion } from 'framer-motion';
import { css, styled } from 'styled-components';

import { accordionHorizontal, accordionTransition, AccordionVariant } from '@pkg/motion';
import { styledLayout } from '@pkg/primitives';

import { tokens } from './FiltersSidebar.tokens.ts';

interface SidebarProps {
    // TODO: This variant is not currently used and may not even work.
    $sticky?: boolean;
}

interface ScrollContainerProps {
    $scrollable?: boolean;
}

export const Sidebar = styled(motion.div).attrs({
    variants: accordionHorizontal,
    initial: AccordionVariant.Hidden,
    animate: AccordionVariant.Show,
    exit: AccordionVariant.Hidden,
    transition: accordionTransition,
})<SidebarProps>`
    flex: 0 0 auto;
    height: 100%;
    overflow: hidden;

    ${({ $sticky }) =>
        $sticky &&
        css`
            position: sticky;
            top: ${tokens.stickyTop}px;
        `};
`;

export const Interior = styled.div`
    width: ${tokens.width + tokens.gap}px;
    height: 100%;
    // Required left-only padding to keep non-grouped
    // input focus-rings within the overflow container.
    padding-left: ${tokens.safetyPadding}px;
`;

export const ScrollContainer = styled.div<ScrollContainerProps>`
    padding-right: ${tokens.gap}px;

    ${({ $scrollable }) =>
        $scrollable &&
        css`
            --yat_scrollbar-thumb-color: ${({ theme }) => theme.shades.purple['20']};
            margin-right: ${tokens.gap / 2}px;
            padding-right: ${tokens.gap / 2}px;
            height: 100%;
            overflow-y: scroll;

            ${styledLayout.scrollbar({
                thumbColor: 'var(--yat_scrollbar-thumb-color)',
                trackColor: 'transparent',
            })};
        `};
`;
